import React from "react";
import { Helmet } from "react-helmet";

import Page from "../../components/layout/Page";

//@ts-ignore
import showroomBg from "../../assets/images/showroom-hero.jpg";
//@ts-ignore
import cat4 from "../../assets/images/proiectare.jpg";
//@ts-ignore
import img5 from "../../assets/images/pages/5.jpg";
//@ts-ignore
import img6 from "../../assets/images/pages/6.jpg";
//@ts-ignore
import headerImage from "../../assets/images/headers/h-4.jpg";

export default function Cladiri() {
  return (
    <Page>
      {
        //@ts-ignore
        <Helmet>
          <title>
            Sisteme Smart Home & Clădiri Inteligente | Asempera Cluj
          </title>
          <meta
            name="description"
            content={`Asempera, partener Loxone în Cluj-Napoca. Proiectăm sisteme smart home și automatizări pentru clădiri inteligente, focusate pe confort, siguranță și eficiență.`}
          />
        </Helmet>
      }
      <div
        className="page-title with-background"
        style={{ backgroundImage: `url(${headerImage})` }}
      >
        <div className="shade"></div>
        <h1>Clădiri inteligente</h1>
      </div>
      <div className="an-section">
        <div className="an-content">
          <p>
            Deoarece fiecare afacere are obiective specifice, nu oferim soluții
            standard. Platforma noastră de automatizare este complet
            personalizabilă, proiectată să se alinieze precis nevoilor concrete
            ale proiectului dumneavoastră.
          </p>
          <p>
            <strong>Spații de birouri:</strong> Maximizarea productivității
            angajaților și optimizarea costurilor operaționale.
          </p>
          <p>
            <strong>Industria hotelieră:</strong> Crearea unei experiențe
            superioare pentru oaspeți prin confort și servicii integrate.
          </p>
          <p>
            <strong>Spații de retail:</strong> Construirea unei atmosfere de
            brand memorabile și securizarea eficientă a locației.
          </p>
        </div>
      </div>
      <div className="an-section bg-1">
        <div className="an-content flex align-center">
          <div className="an-col w-6">
            <h4 className="strong">
              Sistemul nostru este construit pe patru piloni esențiali,
              proiectați să lucreze în perfectă armonie.
            </h4>
            <p>
              <strong>Eficiență energetică și reducerea costurilor:</strong>{" "}
              Monitorizăm și optimizăm în timp real consumul de energie.
              Sistemul ajustează automat iluminatul, climatizarea și alte
              echipamente în funcție de program, prezență umană și condițiile
              externe, generând economii substanțiale și predictibile.
            </p>
            <p>
              <strong>Confort și productivitate:</strong> Creăm un mediu
              interior de înaltă calitate. Controlul automat al calității
              aerului, al temperaturii și al intensității luminii asigură un
              nivel superior de confort, care se traduce direct în
              productivitatea angajaților și în satisfacția clienților.
            </p>
            <p>
              <strong>Securitate integrată si control acces:</strong>{" "}
              Protejați-vă activele și personalul cu un sistem de securitate
              unic. Integrați monitorizarea video, sistemele de alarmă și
              controlul accesului într-o singură interfață, cu reguli
              personalizate și alerte automate.
            </p>
          </div>
          <div className="an-col w-6">
            <img src={img5} className="max-400 center"></img>
          </div>
        </div>
      </div>
      <div className="an-section">
        <div className="an-content flex align-center">
          <div className="an-col w-6 order-2-mobile">
            <img src={img6} className="max-400 center"></img>
            <a href="/#contact" className="btn btn-primary show-on-mobile">
              Solicitați o consultanță tehnică.
            </a>
          </div>
          <div className="an-col w-6 order-1-mobile">
            <p>
              Lucrăm direct cu dumneavoastră pentru a transpune obiectivele de
              business în funcționalități automate inteligente. Rezultatul este
              o <strong>soluție scalabilă</strong>,{" "}
              <strong>adaptată perfect</strong> mărimii și complexității
              clădirii, pregătită să evolueze odată cu afacerea dumneavoastră.
            </p>
            <p>
              Primul pas este o discuție tehnică pentru a înțelege obiectivele
              proiectului dumneavoastră. Echipa noastră de specialiști din{" "}
              <strong>Cluj-Napoca</strong> este aici pentru a vă oferi o
              evaluare și o propunere de soluție personalizată
            </p>
            <a href="/#contact" className="btn btn-primary hide-on-mobile">
              Solicitați o consultanță tehnică.
            </a>
          </div>
        </div>
      </div>
    </Page>
  );
}
